import * as React from 'react';
import { useState, MouseEvent, useEffect } from 'react';
import { styled, alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
// import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import { ListItemButton, Collapse, List, ListSubheader, makeStyles, Typography, Grid, TextField, Button, useTheme, Badge, Paper} from '@mui/material';
import { Popover as MuiPopover } from '@mui/material';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import ExpandLessOutlinedIcon from '@mui/icons-material/ExpandLessOutlined';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from "@mui/material/MenuItem";
import Menu, { MenuProps } from "@mui/material/Menu";
import LockResetIcon from '@mui/icons-material/LockReset';
import LogoutIcon from '@mui/icons-material/Logout';
import { keys } from 'lodash';
import Avatar from '@mui/material/Avatar';
import CircularProgress from '@mui/material/CircularProgress';
import { IUser } from "../../utils/auth.types";
import SettingsTwoToneIcon from '@mui/icons-material/SettingsTwoTone';
import NotificationsActiveTwoToneIcon from '@mui/icons-material/NotificationsActiveTwoTone';
import SearchTwoToneIcon from '@mui/icons-material/SearchTwoTone';
import PersonOutlineTwoToneIcon from '@mui/icons-material/PersonOutlineTwoTone';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import StoreTwoToneIcon from '@mui/icons-material/StoreTwoTone';
import Logo1 from './icon.png';
import Logo2 from './wareozo.png';
import ShoppingCartTwoToneIcon from '@mui/icons-material/ShoppingCartTwoTone';
import PeopleAltTwoToneIcon from '@mui/icons-material/PeopleAltTwoTone';
import LocalShippingTwoToneIcon from '@mui/icons-material/LocalShippingTwoTone';
import StorefrontTwoToneIcon from '@mui/icons-material/StorefrontTwoTone';
import BadgeTwoToneIcon from '@mui/icons-material/BadgeTwoTone';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import PictureAsPdfTwoToneIcon from '@mui/icons-material/PictureAsPdfTwoTone';

import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { logout, loadUserPermissions } from '../../store/authSlice';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import paperProps from '../../utils/menuPaperProps';
// import ProfileUpdate from '../UpdateProfilePicture/UpdateProfilePicture';
import SidebarListItem from './SidebarListItem';
import SwitchAccount from '../SwitchAccount/SwitchAccount';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import ProfileMenuItem from '../ProfileMenuItem/ProfileMenuItem';
import { StyledList, StyledToolBar } from './Navigation.styles';
// import Collapse from '@mui/material/Collapse';
import StoreIcon from '@mui/icons-material/Store';
import InventoryIcon from '@mui/icons-material/Inventory';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PaidIcon from '@mui/icons-material/Paid';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import HelpIcon from '@mui/icons-material/Help';
import PaymentIcon from '@mui/icons-material/Payment';
import SettingsIcon from '@mui/icons-material/Settings';
import ApartmentIcon from '@mui/icons-material/Apartment';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SummarizeIcon from '@mui/icons-material/Summarize';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import GroupsIcon from '@mui/icons-material/Groups';
import PaymentsIcon from '@mui/icons-material/Payments';
import "./Navigation.css";
import AttachMoneyTwoToneIcon from '@mui/icons-material/AttachMoneyTwoTone';
import ReceiptTwoToneIcon from '@mui/icons-material/ReceiptTwoTone';
import Popover from './Popover';
import { InvoiceRoute, Utils, VocuherCategory, VocuherTypes } from '../../utils/common-utils';
import CustomBreadcrumbs from '../Breadcrumbs/Breadcrumbs';

import AddIcon from '@mui/icons-material/Add';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const drawerWidth = 80;

const loaderStyle = {
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })<{
  open?: boolean;
  user: IUser;
  isloggedin?: any;
}>(({ theme, open, user, isloggedin }) => {
  console.log({ open, isloggedin })
  return ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    minHeight: '100vh',
    marginLeft: `-${open ? 0 : isloggedin === 'true' ? drawerWidth : 0}px`,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
});

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-start',
  minHeight: '50px',
  paddingTop: '8px',
  paddingBottom: '8px',
  paddingLeft: '24px'
}));

const StyledMenu = styled((props: MenuProps) => (
<Menu
    elevation={0}
    anchorOrigin={{
    vertical: 'bottom',
    horizontal: 'right',
    }}
    transformOrigin={{
    vertical: 'top',
    horizontal: 'right',
    }}
    {...props}
/>
))(({ theme }) => ({
'& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
    theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
    'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
    padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
    '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
    },
    '&:active': {
        backgroundColor: alpha(
        theme.palette.secondary.main,
        theme.palette.action.selectedOpacity,
        ),
    }
    },
},
}));

export default function Navigation() {
  const theme = useTheme(); // Get theme object
  const [open, setOpen] = useState(true);
  const [search, setSearch] = useState(false);
  const [openDropDownMenu, SetOpenDropDownMenu] = useState<string[]>([]);
  const [showResetPassword, setShowResetPassword] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [notificationAnchorEl, setNotificationAnchorEl] = useState<null | HTMLElement>(null);
  const [notifications, setNotifications] = useState([
    { id: 1, title: 'New Invoice Created', message: 'Invoice #INV-2024-001 has been created', time: '5 minutes ago', read: false },
    { id: 2, title: 'Payment Received', message: 'Payment of ₹50,000 received from ABC Corp', time: '1 hour ago', read: false },
    { id: 3, title: 'Reminder', message: 'Invoice #INV-2024-002 is due tomorrow', time: '2 hours ago', read: true },
    { id: 4, title: 'New Customer Added', message: 'XYZ Ltd has been added as a new customer', time: '3 hours ago', read: true },
  ]);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoggedIn, sidebarCategories, user, switchingAccount, isSelfRegistered } = useAppSelector((state) => state.auth);

  const { selectedAccount } = useAppSelector(state => state.auth);
  
  // Debug logging for sidebar categories
  console.log('🗂️ Navigation component - sidebarCategories from Redux:', sidebarCategories);
  console.log('🗂️ Navigation component - sidebarCategories keys:', Object.keys(sidebarCategories || {}));

  const isMenuOpen = Boolean(anchorEl);

  const [selectedItem, setSelectedItem] = useState<string | null>(null);

  const handleSelect = (item: string) => {
    if(item.toLowerCase() == 'Overview'.toLowerCase()) navigate(`/sales/${VocuherTypes.GST_INVOICE}`)
    setSelectedItem(item);
  };


  // sort the category.
  const sidebarSortedCategories = keys(sidebarCategories).sort((a, b) => a.localeCompare(b));

  // const [open, setOpen] = useState(true);
  const toogleDrawer = (menuState: boolean) => {
    setOpen(!menuState);
    setDashboardOpen(!dashboardOpen);
  };
  const [dashboardOpen, setDashboardOpen] = React.useState(false);

  const handleDashboardClick = () => {
    setDashboardOpen(!dashboardOpen);
  };

  const [paymentsOpen, setPaymentsOpen] = React.useState(false);

  const handlePaymentsClick = () => {
    setPaymentsOpen(!paymentsOpen);
  };

  const [selectedIndex, setSelectedIndex] = React.useState(1);

  const handleListItemClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number,
  ) => {
    setSelectedIndex(index);
  };

  const handleMenuDropDownClick = (clickedMenu: string) => {
    if (openDropDownMenu.some(item => item === clickedMenu)) {
      let array = openDropDownMenu.filter((item) => item !== clickedMenu);
      SetOpenDropDownMenu(array)
    } else {
      SetOpenDropDownMenu(oldArray => [...oldArray, clickedMenu])
    }
  };

  /**
 * Handler for My account management click.
 */
  const handleAccountManagement = () => {
    handleMenuClose();
    navigate(`/account/account-details/${selectedAccount._id}`);
    setDashboardOpen(false);
  }
  /**
* Handler for settings click.
*/
  const handleSettings = () => {
    handleMenuClose();
    navigate('/settings');
    setDashboardOpen(false);
  }

  /**
* Handler for My businesses click.
*/
  const handleMyBusinesses = () => {
    handleMenuClose();
    navigate(`/account`);
    setDashboardOpen(false);
  }

  // Map of icon and resources.
  const sidebarIconHash: any = {
    Dashboard: <DashboardIcon />,
    Administrative: <AdminPanelSettingsIcon />,
    Payments: <PaymentsIcon />
  };

  const currentPathName = window.location.href;
  const curPage = currentPathName.split('/');

  const [anchorEl1, setAnchorEl1] = React.useState<HTMLElement | null>(null);
  const [anchorEl6, setAnchorEl6] = React.useState<HTMLElement | null>(null);
  const [openPopover, setOpenPopover] = useState(false);
  const openTrxMenu = Boolean(anchorEl6);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl1(event.currentTarget);
    setOpenPopover(true);
  };

  const handlePopoverClose = () => {
    setAnchorEl1(null);
    setOpenPopover(false);
  };

  const handleNewButtonClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl6(event.currentTarget);
  };

  const handleNewButtonClose = () => {
    setAnchorEl6(null);
  };

  const handleNewTransaction = (vCategory: string, vType: string) => {
    let redirectTo = '';
    const invoiceMeta = Utils.getInvoiceRouteName(vType);
    if (vCategory && vType){
        redirectTo = `/${vCategory}/invoice/${invoiceMeta.routeName}/create`;
    } 
    navigate(redirectTo);
    handleNewButtonClose()
  };

  const open1 = Boolean(anchorEl1);

  const handleNotificationClick = (event: React.MouseEvent<HTMLElement>) => {
    setNotificationAnchorEl(event.currentTarget);
  };

  const handleNotificationClose = () => {
    setNotificationAnchorEl(null);
  };

  const handleMarkAsRead = (notificationId: number) => {
    setNotifications(prev => 
      prev.map(notif => 
        notif.id === notificationId ? { ...notif, read: true } : notif
      )
    );
  };

  const handleMarkAllAsRead = () => {
    setNotifications(prev => 
      prev.map(notif => ({ ...notif, read: true }))
    );
  };

  const unreadCount = notifications.filter(n => !n.read).length;
  const notificationOpen = Boolean(notificationAnchorEl);

  // sidebar menu list.
  const sidebarMenusList = (
    <>
      {/* <StyledList sx={{ p: 0 ,overflow: "scroll",height:"100%" }}>
        {sidebarSortedCategories.map((category, idx) => (
          <Box key={idx}>
            <ListItem disablePadding divider key={category + '_' + idx}>
              <ListItemButton className='custom-sidebar-menu'
                selected={openDropDownMenu.some(item => item === category)}
                onClick={() => handleMenuDropDownClick(category)}
                disableRipple
              >
                <ListItemIcon>
                
                  {sidebarIconHash[category]}
                </ListItemIcon>
                <ListItemText primary={category} />
                {
                  openDropDownMenu.some(item => item === category) ?
                    <ExpandLessOutlinedIcon style={{ fontSize: '1.2rem' }} /> :
                    <ExpandMoreOutlinedIcon style={{ fontSize: '1.2rem' }} />
                }
              </ListItemButton>
            </ListItem>
            <Collapse key={category + 'a' + idx} in={openDropDownMenu.some(item => item === category)} timeout="auto" unmountOnExit>
              {sidebarCategories[category].map(({ displayName, to }, idxx) => (
                (displayName!=='Invoices') ? 
                <SidebarListItem
                  sx={{ '&.Mui-selected': { borderRight: '2px solid', borderColor: 'primary.main' } }}
                  key={idxx}
                  title={displayName}
                  open={open}
                  selected={location.pathname.includes(to)}
                  onClick={() => navigate(to)}
                /> : ''
              ))}
            </Collapse>
          </Box>
        ))}
      </StyledList> */}
      <Divider />

      <List
        component="nav" className='custom-sidebar'
        aria-labelledby="nested-list-subheader"
        sx={{
          width: '100%',
          backgroundColor: '#e9ecf1', paddingLeft: -5,
          color: '#183f58', marginTop: 1,
          p: 0, overflow: "hidden", height: "100%",
          // selected and (selected + hover) states
          // '&& .Mui-selected, && .Mui-selected:hover': {
          //   bgcolor: 'rgb(230, 247, 255)',
          //   backgroundColor: '#f1c40f',
          //   '&, & .MuiListItemIcon-root': {
          //     color: '#183f58',
          //   },
          // },
          '& .MuiListItemButton-root': {
            backgroundColor: '#e9ecf1',
            '&, & .MuiListItemIcon-root': {
              color: '#183f58',
            },
          },

          '& .MuiListItemButton-root:hover': {
            bgcolor: 'rgba(230,250,255,255)',
            backgroundColor: 'rgba(230,250,255,255)',
            '&, & .MuiListItemIcon-root': {
              color: '#183f58',
            },
          },
          // overflow: "scroll",
          // height:"100%"
        }}

      >
        {/* <ListItemButton className='custom-sidebar-menu' 
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        onClick={handleDashboardClick}>
          <span><DashboardIcon sx={{ width:25,marginLeft:"2px" }} /><span>Dashboard</span></span>
        </ListItemButton>

        <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: 'none',
        }}
        open={open1}
        anchorEl={anchorEl1}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        onMouseEnter={handlePopoverOpen}
        onClose={handlePopoverClose}
        onClick={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography sx={{ p: 1 }}>I use Popover.</Typography>
      </Popover>

        <Collapse in={dashboardOpen} timeout="auto" unmountOnExit>
          <ListItemButton className='custom-sidebar-menu' onClick={() => navigate('/AR')} sx={{ pl: '44px', pt: '0px', pr: '0px', pb: '0px' }}
            selected={location.pathname.includes('AR')}>
            <AccountBalanceIcon sx={{ width: "15px", ml: "13px", mr: "12px" }} />
            <SidebarListItem
              sx={{ pl: '0px', pb: '4px', '&.Mui-selected': { borderRight: '2px solid', borderColor: 'primary.main' } }}
              onClick={() => navigate('/AR')} title={'Sales'} selected={location.pathname.includes('AR')} open={open}>
            </SidebarListItem>
          </ListItemButton>
          <ListItemButton className='custom-sidebar-menu' onClick={() => navigate('/AP')} sx={{ pl: '44px', pt: '0px', pr: '0px', pb: '0px' }}
            selected={location.pathname.includes('AP')}>
            <PaymentIcon sx={{ width: "15px", ml: "13px", mr: "12px" }} />
            <SidebarListItem
              sx={{ pl: '0px', pb: '4px', '&.Mui-selected': { borderRight: '2px solid', borderColor: 'primary.main' } }}
              onClick={() => navigate('/AP')} title={'Purchase'} selected={location.pathname.includes('AP')} open={open}>
            </SidebarListItem>
          </ListItemButton>
        </Collapse> */}

        <List component="div" disablePadding sx={{
          width: '100%', bgcolor: '#e9ecf1', paddingTop: '5px', overflow: 'auto', overflowX: 'hidden', height: '100%',
          '&::-webkit-scrollbar': {
            display: 'none'
          },
          scrollbarWidth: 'none',
          '-ms-overflow-style': 'none',
          '&& .Mui-selected, && .Mui-selected:hover': {
            bgcolor: '#fff',
            '&, & .MuiListItemIcon': {
              color: '#059669 !important',
              borderRight: '3.5px solid',
              borderColor: '#059669 !important'
            },
          },
          '& .MuiListItemButton:hover': {
            bgcolor: '#fff;',
            '&, & .MuiListItemIcon': {
              color: 'black', borderRadius: '10px'
            },
          }
        }}
        >
          {/* <ListItemButton className='custom-sidebar-menu' onClick={() => { navigate('/home'); setDashboardOpen(false); }} selected={location.pathname.includes('home')}>
            <div><DashboardIcon sx={{ fontSize:30}} /></div>
            <h5>Dashboard</h5>
          </ListItemButton> */}

          <ListItemButton className='custom-sidebar-menu' onClick={() => { navigate('/payments'); setDashboardOpen(false); }} selected={location.pathname.includes('payments')}>
            <div className={location.pathname.includes('payments') ? 'custom-sidebar-menu_div2' : "custom-sidebar-menu_div"}><CurrencyRupeeIcon sx={{ fontSize: 24, marginTop: 0.1 }} /></div>
            <h5>Payments</h5>
          </ListItemButton>

          <ListItemButton className='custom-sidebar-menu' onClick={() => { navigate('/expenses'); setDashboardOpen(false); }} selected={location.pathname.includes('expenses')}>
            <div className={location.pathname.includes('expenses') ? 'custom-sidebar-menu_div2' : "custom-sidebar-menu_div"}><ReceiptTwoToneIcon sx={{ fontSize: 24, marginTop: 0.1 }} /></div>
            <h5>Expenses</h5>
          </ListItemButton>

          {/* <ListItemButton className='custom-sidebar-menu'
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
            onClick={handleDashboardClick}>
            <span><DashboardIcon sx={{ width: 25, marginLeft: "2px" }} /><span>Dashboard</span></span>
          </ListItemButton> */}

          {/* <Popover 
          content={
            <List component="nav" style={{ width: 200 }}>
              <h4 style={{marginLeft:15, marginBottom:5}}>Dashboard</h4>
              {["Overview", "Reports", "Analytics"].map((item) => (
                <ListItemButton
                  key={item}
                  selected={selectedItem === item}
                  onClick={() => handleSelect(item)}
                >
                  <StoreTwoToneIcon sx={{ fontSize: 24, marginTop: 0.1, marginRight: 1 }} />
                  <ListItemText primary={item} color='primary.main'/>
                </ListItemButton>
              ))}
            </List>
          }
           placement="bottom">
            <ListItemButton className='custom-sidebar-menu' selected={location.pathname.includes('sales')}>
              <div className={location.pathname.includes('sales') ? 'custom-sidebar-menu_div2' : "custom-sidebar-menu_div"} ><DashboardIcon sx={{ fontSize: 24, marginTop: 0.1 }} /></div>
              <h5>Dashboard</h5>
            </ListItemButton>
          </Popover> */}

          {/* <Popover
            id="mouse-over-popover"
            sx={{
              pointerEvents: 'none',
            }}
            open={openPopover}
            anchorEl={anchorEl1}
            anchorOrigin={{
              vertical: 'center',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'center',
              horizontal: 'left',
            }}
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
            PaperProps={{
              onMouseEnter: handlePopoverOpen,
              onMouseLeave: handlePopoverClose,
            }}
            onClose={handlePopoverClose}
            // onClick={handlePopoverClose}
            disableRestoreFocus
          >
            <List style={{ backgroundColor: "#e9ecf1", width: '70px', padding: '10px' }}>
              <ListItemButton className='custom-sidebar-menu' onClick={() => { navigate('/sales'); setDashboardOpen(false); }} selected={location.pathname.includes('sales')}>
                <div className={location.pathname.includes('sales') ? 'custom-sidebar-menu_div2' : "custom-sidebar-menu_div"} ><StoreTwoToneIcon sx={{ fontSize: 24, marginTop: 0.1 }} /></div>
                <h5>Sales</h5>
              </ListItemButton>
              <ListItemButton className='custom-sidebar-menu' onClick={() => { navigate('/sales'); setDashboardOpen(false); }} selected={location.pathname.includes('sales')}>
                <div className={location.pathname.includes('sales') ? 'custom-sidebar-menu_div2' : "custom-sidebar-menu_div"} ><StoreTwoToneIcon sx={{ fontSize: 24, marginTop: 0.1 }} /></div>
                <h5>Sales</h5>
              </ListItemButton>
            </List>
          </Popover> */}

          <ListItemButton className='custom-sidebar-menu' onClick={() => { navigate('/sales'); setDashboardOpen(false); }} selected={location.pathname.includes('sales')}>
            <div className={location.pathname.includes('sales') ? 'custom-sidebar-menu_div2' : "custom-sidebar-menu_div"} ><StoreTwoToneIcon sx={{ fontSize: 24, marginTop: 0.1 }} /></div>
            <h5>Sales</h5>
          </ListItemButton>
          {/* <ListItemButton className='custom-sidebar-menu' onClick={() => { navigate('/sales/estimate'); setDashboardOpen(false); }} selected={location.pathname.includes('sales/estimate')}>
            <AccountBalanceIcon sx={{ width: "15px", ml: "13px", mr: "12px" }} />
            <ListItemText primary="Estimate" />
          </ListItemButton>
          <ListItemButton className='custom-sidebar-menu' onClick={() => { navigate('/sales/credit-note'); setDashboardOpen(false); }} selected={location.pathname.includes('sales/credit-note')}>
            <AccountBalanceIcon sx={{ width: "15px", ml: "13px", mr: "12px" }} />
            <ListItemText primary="Credit Note" />
          </ListItemButton>
          <ListItemButton className='custom-sidebar-menu' onClick={() => { navigate('/sales/debit-note'); setDashboardOpen(false); }} selected={location.pathname.includes('sales/debit-note')}>
            <AccountBalanceIcon sx={{ width: "15px", ml: "13px", mr: "12px" }} />
            <ListItemText primary="Debit Note" />
          </ListItemButton> */}
          {/* <ListItemButton className='custom-sidebar-menu' onClick={() => { navigate('/sales/delivery-note'); setDashboardOpen(false); }} selected={location.pathname.includes('sales/delivery-note')}>
            <AccountBalanceIcon sx={{ width: "15px", ml: "13px", mr: "12px" }} />
            <ListItemText primary="Delivery Note" />
          </ListItemButton> */}

          <ListItemButton className='custom-sidebar-menu' onClick={() => { navigate('/purchases'); setDashboardOpen(false); }} selected={location.pathname.includes('purchases')}>
            {/* <PaymentIcon sx={{ width: "15px", ml: "13px", mr: "12px" }} />
            <ListItemText primary="Purchase" /> */}
            <div className={location.pathname.includes('purchases') ? 'custom-sidebar-menu_div2' : "custom-sidebar-menu_div"} ><ShoppingCartTwoToneIcon sx={{ fontSize: 24, marginTop: 0.5 }} /></div>
            <h5>Purchases</h5>
          </ListItemButton>

          <ListItemButton className='custom-sidebar-menu' onClick={() => { navigate('/customers'); setDashboardOpen(false); }} selected={location.pathname.includes('customers')}>
            {/* <PeopleAltIcon sx={{ width: "15px", ml: "13px", mr: "12px" }} />
            <ListItemText primary="Customers" /> */}
            <div className={location.pathname.includes('customers') ? 'custom-sidebar-menu_div2' : "custom-sidebar-menu_div"} ><PeopleAltTwoToneIcon sx={{ fontSize: 24, marginTop: 0.2 }} /></div>
            <h5>Buyers</h5>
          </ListItemButton>

          <ListItemButton className='custom-sidebar-menu' onClick={() => { navigate('/suppliers'); setDashboardOpen(false); }} selected={location.pathname.includes('suppliers')}>
            {/* <StoreIcon sx={{ width: "15px", ml: "13px", mr: "12px" }} />
            <ListItemText primary="Suppliers" /> */}
            <div className={location.pathname.includes('suppliers') ? 'custom-sidebar-menu_div2' : "custom-sidebar-menu_div"}><LocalShippingTwoToneIcon sx={{ fontSize: 24, marginTop: 0.3 }} /></div>
            <h5>Suppliers</h5>
          </ListItemButton>

          <ListItemButton className='custom-sidebar-menu' onClick={() => { navigate('/inventory'); setDashboardOpen(false); }} selected={location.pathname.includes('inventory')}>
            {/* <InventoryIcon sx={{ width: "15px", ml: "13px", mr: "12px" }} />
            <ListItemText primary="Inventory" /> */}
            <div className={location.pathname.includes('inventory') ? 'custom-sidebar-menu_div2' : "custom-sidebar-menu_div"}><StorefrontTwoToneIcon sx={{ fontSize: 24, marginTop: 0.3 }} /></div>
            <h5>Inventory</h5>
          </ListItemButton>

          <ListItemButton className='custom-sidebar-menu' onClick={() => { navigate('/employee'); setDashboardOpen(false); }} selected={location.pathname.includes('employee')}>
            {/* <InventoryIcon sx={{ width: "15px", ml: "13px", mr: "12px" }} />
            <ListItemText primary="Inventory" /> */}
            <div className={location.pathname.includes('employee') ? 'custom-sidebar-menu_div2' : "custom-sidebar-menu_div"}><BadgeTwoToneIcon sx={{ fontSize: 24, marginTop: 0.1 }} /></div>
            <h5>Employee</h5>
          </ListItemButton>
          <ListItemButton className='custom-sidebar-menu' onClick={() => { navigate('/reports'); setDashboardOpen(false); }} selected={location.pathname.includes('reports')}>
            {/* <InventoryIcon sx={{ width: "15px", ml: "13px", mr: "12px" }} />
            <ListItemText primary="Inventory" /> */}
            <div className={location.pathname.includes('reports') ? 'custom-sidebar-menu_div2' : "custom-sidebar-menu_div"}><PictureAsPdfTwoToneIcon sx={{ fontSize: 24, marginTop: 0.1 }} /></div>
            <h5>Reports</h5>
          </ListItemButton>
          
          
          {/*
          <ListItemButton className='custom-sidebar-menu' onClick={() => {navigate('/reports');setDashboardOpen(false);}} selected={location.pathname.includes('reports')}>
            <SummarizeIcon sx={{ width: "15px", ml: "13px", mr: "12px" }} /> 
            <ListItemText primary="Reports" />
          </ListItemButton>
        */}

          <ListItemButton className='custom-sidebar-menu' onClick={() => { navigate('/users'); setDashboardOpen(false); }} selected={location.pathname.includes('users')}>
            <div><GroupsIcon sx={{ fontSize:30}} /></div>
            <h5>Members</h5>
          </ListItemButton>
          { /*
          <ListItemButton className='custom-sidebar-menu' onClick={() => {navigate('/my-profile');setDashboardOpen(false);}} selected={location.pathname.includes('my-profile')}>
            <AccountCircleIcon sx={{ width: "15px", ml: "13px", mr: "12px" }} /> 
              <ListItemText primary="My Profile" />
          </ListItemButton>

          <ListItemButton className='custom-sidebar-menu' onClick={() => {navigate('/how-to-use-magnus');setDashboardOpen(false);}} selected={location.pathname.includes('how-to-use-magnus')}>
            <HelpIcon sx={{ width: "15px", ml: "13px", mr: "12px" }} />            
              <ListItemText primary="How to use Magnus?" />
          </ListItemButton>

          <ListItemButton className='custom-sidebar-menu' onClick={() => {navigate('/live-chat-support');setDashboardOpen(false);}} selected={location.pathname.includes('live-chat-support')}>
            <SupportAgentIcon sx={{ width: "15px", ml: "13px", mr: "12px" }} /> 
              <ListItemText primary="Live Chat Support " />
          </ListItemButton>
          */}
        </List>
      </List>
      {/* </StyledList> */}
    </>
  );

  /**
  * Close the sidebar if user is logging out and sidebar was open.
  */
  useEffect(() => {
    console.log({ user });
    setShowResetPassword(!(user.auth && (user.auth.google || user.auth.microsoft)));
  }, [user]);

  useEffect(() => {
    // if (!isLoggedIn) {
    //   setOpen(false);
    // }

    if (curPage.includes('home')) {
      setDashboardOpen(!dashboardOpen);
    } else {
      setDashboardOpen(false);
    }
  }, [isLoggedIn]);

  // Load user permissions when user is logged in
  useEffect(() => {
    if (isLoggedIn && user?._id) {
      dispatch(loadUserPermissions(user._id));
    }
  }, [isLoggedIn, user?._id, selectedAccount?._id, dispatch]);

  /**
   * Method to handle profile menu open/close.
   * @param event 
   */
  const handleProfileMenuOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfileMenuOpen2 = (val: any) => {
    setAnchorEl(val);
  };

  /**
  * Method to close profile menu.
  */
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  /**
 * Handler for reset password click.
 */
  const handleResetPassword = () => {
    handleMenuClose();
    navigate('/reset-password');
    setDashboardOpen(false);
  }

  /**
   * Handler for logout.
   */
  const handleLogout = () => {
    handleMenuClose();

    dispatch(logout());
    navigate('/signin', { replace: true });
    setDashboardOpen(false);
  }

  /**
   * Profile Menu placement and menu items
   */
  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      id={menuId}
      keepMounted
      open={isMenuOpen}
      onClose={handleMenuClose}
      PaperProps={paperProps}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      sx={{ padding: '10px' }}
    >
      {/* <ProfileUpdate handleMenuClose={handleMenuClose} /> */}
      <ProfileMenuItem></ProfileMenuItem>
      <Divider sx={{ mt: 1 }} />
      <MenuItem onClick={handleAccountManagement}>
        <ListItemIcon>
          < ManageAccountsIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>My Business Information</ListItemText>
      </MenuItem>
      <MenuItem onClick={handleMyBusinesses}>
        <ListItemIcon>
          <ApartmentIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>My Businesses</ListItemText>
      </MenuItem>
      {/*<MenuItem onClick={handleSettings}>
        <ListItemIcon>
          <SettingsIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Settings</ListItemText>
      </MenuItem>*/}
      {showResetPassword && <MenuItem onClick={handleResetPassword}>
        <ListItemIcon>
          <LockResetIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Reset Password</ListItemText>
      </MenuItem>}
      <MenuItem onClick={handleLogout}>
        <ListItemIcon>
          <LogoutIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Logout</ListItemText>
      </MenuItem>
    </Menu>
  );

  const notificationMenu = (
    <MuiPopover
      id="notification-menu"
      anchorEl={notificationAnchorEl}
      keepMounted
      open={notificationOpen}
      onClose={handleNotificationClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      PaperProps={{
        sx: {
          width: 380,
          maxHeight: 500,
          mt: 1.5,
        }
      }}
    >
      <Box sx={{ p: 2, borderBottom: '1px solid #e0e0e0' }}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Notifications
          </Typography>
          {unreadCount > 0 && (
            <Button 
              size="small" 
              onClick={handleMarkAllAsRead}
              sx={{ textTransform: 'none' }}
            >
              Mark all as read
            </Button>
          )}
        </Grid>
      </Box>
      
      <List sx={{ p: 0, maxHeight: 400, overflow: 'auto' }}>
        {notifications.length === 0 ? (
          <Box sx={{ p: 3, textAlign: 'center' }}>
            <Typography color="textSecondary">No notifications</Typography>
          </Box>
        ) : (
          notifications.map((notification) => (
            <ListItem
              key={notification.id}
              sx={{
                borderBottom: '1px solid #f0f0f0',
                backgroundColor: notification.read ? 'transparent' : '#f5f5f5',
                '&:hover': {
                  backgroundColor: '#fafafa',
                },
                cursor: 'pointer',
                p: 2,
              }}
              onClick={() => handleMarkAsRead(notification.id)}
            >
              <Box sx={{ width: '100%' }}>
                <Grid container justifyContent="space-between" alignItems="flex-start">
                  <Grid item xs={10}>
                    <Typography variant="subtitle2" sx={{ fontWeight: notification.read ? 400 : 600 }}>
                      {notification.title}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ mt: 0.5 }}>
                      {notification.message}
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    {!notification.read && (
                      <Box
                        sx={{
                          width: 8,
                          height: 8,
                          borderRadius: '50%',
                          backgroundColor: '#1976d2',
                          ml: 'auto',
                        }}
                      />
                    )}
                  </Grid>
                </Grid>
                <Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: 'block' }}>
                  {notification.time}
                </Typography>
              </Box>
            </ListItem>
          ))
        )}
      </List>
    </MuiPopover>
  );

  const drawer = (
    <Drawer
      sx={{
        width: drawerWidth + 10,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          // margin:3
          height: '100vh',
          // borderRadius:4,
          // border:'.5px solid #9da7b7',
          border: '1px solid #dadcdf',
          // boxShadow: 'rgba(17, 17, 26, 0.1) 0px 0px 16px',
          boxShadow: 'none',
          backgroundColor: '#e9ecf1',
          overflowX: 'hidden',
          transform: 'none',
          transition: 'transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms',
          padding: 0,
        },
      }}
      variant="persistent"
      anchor="left"
      open={true}
    >
      <DrawerHeader style={{ backgroundColor: '#e9ecf1' }}>
        <div style={{ width: 75, marginLeft: -22, textAlign: 'center' }}>
          <Box
            component="img"
            sx={{ width: 60, cursor: 'pointer' }}
            src={Logo1}
            alt="Wareozo"
            onClick={() => { navigate('/'); setDashboardOpen(false); }}
          />
          <Box
            component="img"
            sx={{ width: 75, cursor: 'pointer', marginTop: -5 }}
            src={Logo2}
            alt="Wareozo"
            onClick={() => { navigate('/'); setDashboardOpen(false); }}
          />
        </div>
      </DrawerHeader>
      {sidebarMenusList}
    </Drawer>
  );

  const profileMenu = (
    <Box display="flex" alignItems={'center'}>
      {/*<HelpIcon sx={{mr:'15px', color:'primary.main', cursor:'pointer'}}/>
      <NotificationsIcon sx={{mr:'10px' , color:'primary.main', cursor:'pointer'}}/>*/}
      {/* {!isSelfRegistered && <SwitchAccount />} */}
      <IconButton
        size="small"
        edge="end"
        aria-label="account of current user"
        aria-controls={menuId}
        aria-haspopup="true"
        onClick={handleProfileMenuOpen}
        color="inherit"
        className="profileIcon"
        disableRipple
      >
        {/* <Typography sx={{ mr: 1 }}>{user.name}</Typography> */}
        <Avatar
          alt={user?.name}
          imgProps={{ "referrerPolicy": 'no-referrer' }}
          src={`${user?.profilePic}`}
        />
      </IconButton>
    </Box>
  )


  return switchingAccount ? (
    <Box sx={loaderStyle}>
      <CircularProgress />
    </Box>
  ) : (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      {(isLoggedIn && user && user?._id) && <>
        {/* <AppBar open={true} style={{ width: search ? '44%' : '23.2%', transition: '0.5s' }} color="transparent" elevation={0}>
          <Box sx={{ borderRadius: '12px', border: '3px solid #e9ecf1', backgroundColor: '#e9ecf1', height: 56, marginTop: '18px', marginRight: 3 }}>
            <Grid container>
              <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p: 1.3, pr: 1.6, pl: 1, bgcolor: '#e9ecf1' }} style={{ borderTopLeftRadius: 8, borderTopRightRadius: 8, height: 50 }} >
                {search ?
                  <div
                    style={{ color: '#545454', transition: '0.3s', backgroundColor: '#fff', border: 'none', height: 39.5, width: 339, borderRadius: 25, marginTop: -5, marginRight: 10 }}
                  // size='small'
                  >
                    <SearchTwoToneIcon style={{ fontSize: 24, marginRight: 0, marginTop: 7, marginLeft: 10 }} onClick={() => setSearch(false)} />
                    <TextField className='c-text-field-2' style={{ width: 290, backgroundColor: 'transparent!important' }} variant="standard"
                      placeholder='Search Anything...'
                      autoFocus
                      onBlur={() => setSearch(false)}
                      InputProps={{
                        style: {
                          fontSize: 16
                        },
                        disableUnderline: true,
                      }} />
                  </div> :
                  <IconButton
                    style={{ color: '#545454', backgroundColor: '#fff', border: 'none', height: 39.5, width: 39.5, marginTop: -5, marginRight: 10 }}
                    size='small'
                    onClick={() => setSearch(true)}
                  >
                    <SearchTwoToneIcon style={{ fontSize: 24 }} />
                  </IconButton>}
              </Grid>
            </Grid>
          </Box>
        </AppBar> */}
        <AppBar open={true} style={{ width: '100%' }} color="transparent" elevation={0}>
          <Box sx={{ border: '3px solid #e9ecf1', backgroundColor: '#e9ecf1', height: 56, textAlign: 'right', paddingRight: '10px', marginLeft: '80px' }}>
            <Grid container >
              <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p: 1.3, pr: 0, pl: 0, bgcolor: '#e9ecf1' }} style={{ height: 50 }} >

                <div style={{float:'right'}}>
                <IconButton
                  style={{ color: '#545454', backgroundColor: '#fff', border: 'none', height: 39.5, width: 39.5, marginTop: -5, marginRight: 10 }}
                  size='small'
                  onClick={handleNotificationClick}
                  aria-label={`${unreadCount} unread notifications`}
                  aria-controls="notification-menu"
                  aria-haspopup="true"
                >
                  <Badge badgeContent={unreadCount} color="error">
                    <NotificationsActiveTwoToneIcon style={{ fontSize: 24 }} />
                  </Badge>
                </IconButton>
                {/* <IconButton
                  style={{ color: '#545454', backgroundColor: '#fff', border: 'none', height: 39.5, width: 39.5, marginTop: -5, marginRight: 10 }}
                  size='small'
                  aria-label="New Transaction"
                  aria-controls={``}
                  aria-haspopup="true"
                >
                  <AddTwoToneIcon style={{ fontSize: 24 }} />
                </IconButton> */}
                {!isSelfRegistered && <SwitchAccount handleProfileMenuOpen={handleProfileMenuOpen2} />}
                <IconButton
                  aria-label="account of current user"
                  aria-controls={menuId}
                  aria-haspopup="true"
                  style={{ color: '#545454', backgroundColor: '#fff', border: 'none', height: 39.5, width: 39.5, marginTop: -5 }}
                  size='small'
                >
                  <SettingsTwoToneIcon style={{ fontSize: 24 }} />
                </IconButton>
                </div>

                  
                  <div style={{ float: 'right', marginRight: 10}}>
                    <Button
                      startIcon={<AddIcon />}
                      size='small'
                      variant="contained"
                      aria-controls={openTrxMenu ? 'demo-customized-menu' : undefined}
                      aria-haspopup="true"
                      aria-expanded={openTrxMenu ? 'true' : undefined}
                      onClick={handleNewButtonClick}
                      endIcon={<KeyboardArrowDownIcon />}
                      sx={{
                        marginTop: "-5px",
                        backgroundColor: '#fff',
                        color: '#545454',
                        border: '1px solid #e0e0e0',
                        height: 40,
                        borderRadius: '20px',
                        px: 2.5,
                        fontWeight: 500,
                        textTransform: 'none',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
                        '&:hover': {
                          backgroundColor: '#059669',
                          color: '#fff',
                          borderColor: '#059669',
                          boxShadow: '0 2px 6px rgba(5, 150, 105, 0.2)',
                          '& .MuiButton-startIcon, & .MuiButton-endIcon': {
                            color: '#fff'
                          }
                        },
                        '&:active': {
                          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)'
                        },
                        '& .MuiButton-startIcon': {
                          color: '#059669',
                          mr: 0.5
                        },
                        '& .MuiButton-endIcon': {
                          color: '#9ca3af',
                          ml: 0.5
                        }
                      }}
                    >
                      New Transaction
                    </Button>
                    <StyledMenu
                        id="demo-customized-menu"
                        MenuListProps={{
                        'aria-labelledby': 'demo-customized-button',
                        }}
                        anchorEl={anchorEl6}
                        open={openTrxMenu}
                        onClose={handleNewButtonClose}
                        PaperProps={{
                            elevation: 0,
                            sx: {
                                overflow: 'visible',
                                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                mt: 1.5,
                                '& ul': {
                                    overflowY: 'auto',
                                    maxHeight: '70vh',
                                    '& li': { 
                                        // borderBottom: '1px solid rgb(211 209 209 / 21%);',
                                        ':hover': {
                                            backgroundColor: theme.palette.primary.main,
                                            color: theme.palette.primary.contrastText,

                                            fontWeight: "600",
                                            transition: "background .10s ease"
                                            // margin: "-10px"
                                        },
                                        // color: 'white'
                                    },
                                    backgroundColor: '#fff',
                                    borderRadius: 2
                                },
                                '& .MuiAvatar-root': {
                                    width: 32,
                                    height: 32,
                                    ml: -0.5,
                                    mr: 1,
                                },
                                '&:before': {
                                    content: '""',
                                    display: 'block',
                                    position: 'absolute',
                                    top: 0,
                                    right: 14,
                                    width: 10,
                                    height: 10,
                                    bgcolor: 'background.paper',
                                    transform: 'translateY(-50%) rotate(45deg)',
                                    zIndex: 0,
                                    backgroundColor: '#fff',
                                },
                            },
                        }}
                    >
                    <div>
                        <MenuItem onClick={(e) => handleNewTransaction(VocuherCategory.SALE, InvoiceRoute.GST_INVOICE)} disableRipple>
                            GST Invoice
                        </MenuItem>
                        <MenuItem onClick={(e) => handleNewTransaction(VocuherCategory.SALE, InvoiceRoute.NON_GST_INVOICE)} disableRipple>
                            Non GST Invoice
                        </MenuItem>
                        <MenuItem onClick={(e) => handleNewTransaction(VocuherCategory.SALE, InvoiceRoute.ESTIMATE)} disableRipple>
                            Quotation/Estimate
                        </MenuItem>
                        
                        <MenuItem onClick={(e) => handleNewTransaction(VocuherCategory.SALE, InvoiceRoute.CREDIT_NOTE)} disableRipple>
                            Credit Note / Sale Return
                        </MenuItem>
                        <MenuItem onClick={(e) => handleNewTransaction(VocuherCategory.SALE, InvoiceRoute.DELIVERY_NOTE)} disableRipple>
                            Delivery Note
                        </MenuItem>
                        <MenuItem onClick={(e) => handleNewTransaction(VocuherCategory.SALE, InvoiceRoute.PROFORMA_INVOICE)} disableRipple>
                            Proforma Invoice
                        </MenuItem>
                        <Divider style={{color: 'white' }} sx={{ my: 0.5,}} />
                        <div>
                            {/* <MenuItem onClick={handleNewButtonClose} disableRipple disabled>
                                Coming Soon
                            </MenuItem> */}
                            <MenuItem onClick={(e) => handleNewTransaction(VocuherCategory.PURCHASE, InvoiceRoute.PURCHASE_INVOICE)} disableRipple>
                                Purchase Invoice
                            </MenuItem>
                            <MenuItem onClick={(e) => handleNewTransaction(VocuherCategory.PURCHASE, InvoiceRoute.PURCHASE_ORDER)} disableRipple>
                                Purchase Order
                            </MenuItem>
                            <MenuItem onClick={(e) => handleNewTransaction(VocuherCategory.PURCHASE, InvoiceRoute.DEBIT_NOTE)} disableRipple>
                                Debit Note / Purchase Return
                            </MenuItem>
                            <Divider style={{color: 'white' }} sx={{ my: 0.5,}} />
                            
                            <MenuItem onClick={handleNewButtonClose} disableRipple disabled>
                                Coming Soon
                            </MenuItem>
                            <MenuItem onClick={handleNewButtonClose} disableRipple disabled style={{marginLeft:'20px'}}>
                                - Payment In / Out
                            </MenuItem>
                        </div>
                    </div>
                        
                    </StyledMenu>
                  </div>
                  <div
                    style={{ color: '#545454', backgroundColor: '#fff', border: 'none', height: 39.5, float:'right', borderRadius: 25, marginTop: -5, marginRight: 15 }}
                  // size='small'
                  >
                    <SearchTwoToneIcon style={{ fontSize: 24, marginRight: 0, marginTop: 7, marginLeft: 10 }} onClick={() => setSearch(false)} />
                    <TextField className='c-text-field-2' style={{ width: 290, backgroundColor: 'transparent!important' }} variant="standard"
                      placeholder='Search Anything...'
                      autoFocus
                      onBlur={() => setSearch(false)}
                      InputProps={{
                        style: {
                          fontSize: 16
                        },
                        disableUnderline: true,
                      }} />
                  </div>
                <div style={{ color: '#545454', float:'left', marginTop: 12, marginRight: 10 }} >
                  <CustomBreadcrumbs />
                </div>
              </Grid>
            </Grid>
            {/* {isLoggedIn && profileMenu} */}
          </Box>
          {/* <StyledToolBar> */}
          {/* {isLoggedIn && <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={() => toogleDrawer(open)}
              edge="start"
              className="openDrawer"
              sx={{ mr: 2 }}
              disableRipple
            >
              {!open ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </IconButton>}
            <Box sx={{ flexGrow: 1 }} />
            {isLoggedIn && profileMenu} */}
          {/* </StyledToolBar> */}
        </AppBar>
      </>
      }

      {isLoggedIn && drawer}
      <Main open={true} user={user} isloggedin={isLoggedIn.toString()} style={{ marginTop: 0, padding: 0 }}>
        <DrawerHeader />
        <Outlet />
        {isLoggedIn && renderMenu}
        {isLoggedIn && notificationMenu}
      </Main>
    </Box>
  );
}

function category(category: any): void {
  throw new Error('Function not implemented.');
}
function MuiList(MuiList: any) {
  throw new Error('Function not implemented.');
}

